import { __extends } from "tslib";
import { Filter3DTaskBase } from './Filter3DTaskBase';
import { ContextGLProgramType } from '../../base/ContextGLProgramType';
var Filter3DHBlurTask = /** @class */ (function (_super) {
    __extends(Filter3DHBlurTask, _super);
    /**
     * Creates a new Filter3DHDepthOfFFieldTask
     * @param amount The maximum amount of blur to apply in pixels at the most out-of-focus areas
     * @param stepSize The distance between samples. Set to -1 to autodetect with acceptable quality.
     */
    function Filter3DHBlurTask(amount, stepSize) {
        if (stepSize === void 0) { stepSize = -1; }
        var _this = _super.call(this) || this;
        _this._stepSize = 1;
        _this._amount = amount;
        _this._data = new Float32Array([0, 0, 0, 1]);
        _this.stepSize = stepSize;
        return _this;
    }
    Object.defineProperty(Filter3DHBlurTask.prototype, "amount", {
        get: function () {
            return this._amount;
        },
        set: function (value) {
            if (this._amount == value)
                return;
            this._amount = value;
            this.invalidateProgram();
            this.updateBlurData();
            this.calculateStepSize();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Filter3DHBlurTask.prototype, "stepSize", {
        get: function () {
            return this._stepSize;
        },
        set: function (value) {
            if (this._stepSize == value)
                return;
            this._stepSize = value;
            this.calculateStepSize();
            this.invalidateProgram();
            this.updateBlurData();
        },
        enumerable: true,
        configurable: true
    });
    Filter3DHBlurTask.prototype.getFragmentCode = function () {
        var temp1 = this._registerCache.getFreeFragmentVectorTemp();
        this._registerCache.addFragmentTempUsages(temp1, 1);
        var temp2 = this._registerCache.getFreeFragmentVectorTemp();
        this._registerCache.addFragmentTempUsages(temp2, 1);
        var temp3 = this._registerCache.getFreeFragmentVectorTemp();
        this._registerCache.addFragmentTempUsages(temp3, 1);
        var inputTexture = this._registerCache.getFreeTextureReg();
        this._inputTextureIndex = inputTexture.index;
        var blur = this._registerCache.getFreeFragmentConstant();
        this._blurIndex = blur.index * 4;
        var code;
        var numSamples = 1;
        code = 'mov ' + temp1 + ', ' + this._uvVarying + '\n' +
            'sub ' + temp1 + '.x, ' + this._uvVarying + '.x, ' + blur + '.x\n';
        code += 'tex ' + temp2 + ', ' + temp1 + ', ' + inputTexture + ' <2d,linear,clamp>\n';
        for (var x = this._realStepSize; x <= this._amount; x += this._realStepSize) {
            code += 'add ' + temp1 + '.x, ' + temp1 + '.x, ' + blur + '.y\n' +
                'tex ' + temp3 + ', ' + temp1 + ', ' + inputTexture + ' <2d,linear,clamp>\n' +
                'add ' + temp2 + ', ' + temp2 + ', ' + temp3 + '\n';
            ++numSamples;
        }
        code += 'mul oc, ' + temp2 + ', ' + blur + '.z\n';
        this._data[2] = 1 / numSamples;
        return code;
    };
    Filter3DHBlurTask.prototype.activate = function (stage, projection, depthTexture) {
        stage.context.setProgramConstantsFromArray(ContextGLProgramType.FRAGMENT, this._data);
    };
    Filter3DHBlurTask.prototype.updateTextures = function (stage) {
        _super.prototype.updateTextures.call(this, stage);
        this.updateBlurData();
    };
    Filter3DHBlurTask.prototype.updateBlurData = function () {
        // todo: must be normalized using view size ratio instead of texture
        var invW = 1 / this._textureWidth;
        this._data[0] = this._amount * .5 * invW;
        this._data[1] = this._realStepSize * invW;
    };
    Filter3DHBlurTask.prototype.calculateStepSize = function () {
        this._realStepSize = this._stepSize > 0 ? this._stepSize : this._amount > Filter3DHBlurTask.MAX_AUTO_SAMPLES ? this._amount / Filter3DHBlurTask.MAX_AUTO_SAMPLES : 1;
    };
    Filter3DHBlurTask.MAX_AUTO_SAMPLES = 15;
    return Filter3DHBlurTask;
}(Filter3DTaskBase));
export { Filter3DHBlurTask };
